<template>
  <b-modal
    id="hospitalization-end-modal"
    title="Souhaitez-vous clôturer l'hospitalisation ?"
    @ok="handleOk"
    ok-title="Clôturer"
    ok-variant="success rounded"
    cancel-title="Annuler"
    cancel-variant="primary rounded"
  >
    <div>
      <b-form-checkbox
        v-model="isDead"
        name="isDead">
        <strong>L'animal est décédé</strong>
      </b-form-checkbox>
    </div>
    <div class="mt-2">
      Cette action ne peut pas être annulée.
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';
export default {
  name: "HospitalizationEndModal",

  props: {
      hospitalization: Object
  },

  data: function () {
    return {
      isDead: false
    }
  },

  methods: {
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let data = new FormData()
      data.append('hospitalizationId', this.$props.hospitalization.id)
      data.append('endDate', new Date().getTime().toString())
      data.append('isDead', this.isDead)

      api({
        method: 'POST',
        url: '/hospitalization/endHospitalization',
        data: data
      })
        .then(response => {
            this.hideModal()
            this.successToast(`Hospitalization clôturée`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('hospitalization-end-modal')
      this.$emit("onHospitalizationEnded")
    },

    successToast(message) {
      this.$bvToast.toast(message, {
          autoHideDelay: 2000,
          toaster: 'b-toaster-bottom-right',
          noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationEndModal.vue